import { Card, Illustration, Text } from "@certn/cascadia-react";
import { CascadiaIllustration } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

export interface EmptyStateProps {
  illustration?: CascadiaIllustration;
  size?: number;
  description: React.ReactNode;
  hideBorder?: boolean;
}

export function EmptyState(props: EmptyStateProps) {
  const { illustration, size = 88 } = props;

  return (
    <Card
      type="large"
      border={props.hideBorder ? "none" : "border-base"}
      background="background-base"
      className={css(styles.card, size > 88 && { gap: "var(--space-6)" })}
    >
      {illustration ? (
        <Illustration aria-hidden="true" name={illustration} size={size} />
      ) : null}
      <div className={styles.titles}>
        <Text style="global/body-secondary" color="text-weak" align="center">
          {props.description}
        </Text>
      </div>
    </Card>
  );
}

const styles = {
  card: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "var(--space-6)",
    gap: "var(--space-4)",
  }),
  titles: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
};
